import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  isDevMode,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideState, provideStore, Store } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { routes } from './app.routes';
import {
  cmsAuthInterceptor,
  localeInterceptor,
  LocaleService,
  previewCmsInterceptor,
  provideCms,
} from '@selfcare/cms';
import { provideRouterStore, routerReducer } from '@ngrx/router-store';
import { UserEffects, userFeature } from '@state';
import { provideEffects } from '@ngrx/effects';
import { GeneralEffects, generalFeature } from '@state/general';
import { CmsEffects, cmsFeature } from '@state/cms';
import { SubscriptionEffects, subscriptionFeature } from '@state/subscription';
import { initializeApp } from '@core/app.initializer';
import { AuthenticationService } from '@core/services';
import { environment } from '@src/environments/environment';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { errorHandlerInterceptor } from '@core/interceptors/error-handler.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
//TODO: Need to rewrite this interceptor
//import { isLimitedUserInterceptor } from '@core/interceptors/is-limited-user.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [LocaleService, Store, AuthenticationService],
      multi: true,
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch()),
    provideAnimations(),
    provideRouter(routes),
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'ignore',
        paramsInheritanceStrategy: 'always',
      })
    ),
    provideStore({
      router: routerReducer,
    }),
    provideRouterStore(),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        cmsAuthInterceptor,
        localeInterceptor,
        previewCmsInterceptor,
        authInterceptor,
        errorHandlerInterceptor,
        //isLimitedUserInterceptor,
      ])
    ),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: !isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
      connectInZone: true,
    }),
    provideState(userFeature),
    provideEffects(UserEffects),
    provideState(generalFeature),
    provideEffects(GeneralEffects),
    provideState(cmsFeature),
    provideEffects(CmsEffects),
    provideState(subscriptionFeature),
    provideEffects(SubscriptionEffects),

    provideCms(environment.cms),
  ],
};
